import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchData } from '@/types/globalSearchApiTypes';
import { sortKeysByOrder } from '../../utils/sortKeysByOrder';
import { AnnouncementsCategory } from './components/AnnouncementsCategory';
import { ClientsCategory } from './components/ClientsCategory';
import { DirectoryCategory } from './components/DirectoryCategory';
import { FaqCategory } from './components/FaqCategory';
import { GalleryCategory } from './components/GalleryCategory';
import { PartnersCategory } from './components/PartnersCategory';
import { ToolkitCategory } from './components/ToolkitCategory';

interface SearchCategoriesProps {
  categories: GlobalSearchData | null;
}

export const SearchCategories = ({ categories }: SearchCategoriesProps) => {
  if (!categories) return null;

  const allCategoryKeys = sortKeysByOrder(categories);

  const renderCategory = (categoryKey: string) => {
    switch (categoryKey) {
      case SEARCH_CATEGORIES.GALLERY:
        return <GalleryCategory key={categoryKey} data={categories.gallery} />;

      case SEARCH_CATEGORIES.FAQ:
        return <FaqCategory key={categoryKey} data={categories.faq} />;

      case SEARCH_CATEGORIES.TOOLKIT:
        return <ToolkitCategory key={categoryKey} data={categories.toolkit} />;

      case SEARCH_CATEGORIES.ANNOUNCEMENTS:
        return <AnnouncementsCategory key={categoryKey} data={categories.announcement} />;

      case SEARCH_CATEGORIES.CLIENTS:
        return <ClientsCategory key={categoryKey} data={categories.client} />;

      case SEARCH_CATEGORIES.PARTNERS:
        return <PartnersCategory key={categoryKey} data={categories.partners} />;

      case SEARCH_CATEGORIES.DIRECTORY:
        return <DirectoryCategory key={categoryKey} data={categories.directory} />;

      default:
        return null;
    }
  };

  return <div className="flex flex-col gap-3 w-full">{allCategoryKeys.map(renderCategory)}</div>;
};
